import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import ultraFull from '../imgs/ultra_full.png'

import { TabView, TabPanel } from 'primereact/tabview';

import Convert from './subcomponents_ultra/Convert';
import Dashboard from './subcomponents_ultra/Dashboard';
import ContractContext from '../ContractContext'; //Required for all dApp components using contracts
import ultraTokenAbi from '../contracts/ultraTokenAbi';
import ausdAbi from '../contracts/ausdAbi';

import UltraBNB from '../imgs/UltraBNB.png';
import UltraBTC from '../imgs/UltraBTC.png';
import UltraETH from '../imgs/UltraETH.png';
import UltraMATIC from '../imgs/UltraMATIC.png';
import UltraADA from '../imgs/UltraADA.png';
import UltraSOL from '../imgs/UltraSOL.png';
import UltraSHIB from '../imgs/UltraSHIB.png';
import UltraDOGE from '../imgs/UltraDOGE.png';
import UltraXRP from '../imgs/UltraXRP.png';
import UltraCAKE from '../imgs/UltraCAKE.png';
import AUSD from '../imgs/AUSD.png';

import BigNumber from 'bignumber.js';
import { get } from "https-browserify";
import Web3 from 'web3';
import HTTPProvider from "web3";

const getTokenImageUrl = (tokenAddress) => {
  return `https://floatie-001.s3.amazonaws.com/56/icon/${tokenAddress}.png`;
};



const selectionPairs = {
  'BNB': 'UltraBNB',
  'UltraBNB': 'BNB',
  'BTC': 'UltraBTC',
  'UltraBTC': 'BTC',
  'ETH': 'UltraETH',
  'UltraETH': 'ETH',
  'MATIC': 'UltraMATIC',
  'UltraMATIC': 'MATIC',
  'ADA': 'UltraADA',
  'UltraADA': 'ADA',
  'SOL': 'UltraSOL',
  'UltraSOL': 'SOL',
  'SHIB': 'UltraSHIB',
  'UltraSHIB': 'SHIB',
  'DOGE': 'UltraDOGE',
  'UltraDOGE': 'DOGE',
  'XRP': 'UltraXRP',
  'UltraXRP': 'XRP',
  'CAKE': 'UltraCAKE',
  'UltraCAKE': 'CAKE',
  'AUSD': 'USDC',
  'USDC': 'AUSD',
};


const ultraSelections = [
  { label: 'UltraBNB', value: 'UltraBNB', img: UltraBNB, address: "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6", decimals: 18 },
  { label: 'UltraBTC', value: 'UltraBTC', img: UltraBTC, address: "0x904B4224acA463666E98f21cC8C54f8D423f6648", decimals: 18 },
  { label: 'UltraETH', value: 'UltraETH', img: UltraETH, address: "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA", decimals: 18 },
  // { label: 'UltraMATIC', value: 'UltraMATIC', img: UltraMATIC, address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984", decimals: 18 },
  { label: 'UltraADA', value: 'UltraADA', img: UltraADA, address: "0x2761c609f3DbA79FFb34d28ab8d9cc2FF381fD3A", decimals: 18 },
  { label: 'UltraSOL', value: 'UltraSOL', img: UltraSOL, address: "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8", decimals: 18 },
  { label: 'UltraSHIB', value: 'UltraSHIB', img: UltraSHIB, address: "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132", decimals: 18 },
  { label: 'UltraDOGE', value: 'UltraDOGE', img: UltraDOGE, address: "0xb014728C841D8Ccca6C236fE04B274D206cc60D0", decimals: 8 },
  { label: 'UltraXRP', value: 'UltraXRP', img: UltraXRP, address: "0x3834303483f139c26bc282528aDee6b7Da103D54", decimals: 18 },
  { label: 'UltraCAKE', value: 'UltraCAKE', img: UltraCAKE, address: "0x58291c58A2c4AEc7Ad24BaA87988dFc39f3FBC25", decimals: 18 },
  { label: 'AUSD', value: 'AUSD', img: AUSD, address: "0x27874A586bafaF54d4Cd0aae368ad9569D06d115", decimals: 18 },
]

const nativeSelections = [
  { label: 'BNB', value: 'BNB', img: getTokenImageUrl("0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c"), address: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c", decimals: 18 },
  { label: 'BTC', value: 'BTC', img: getTokenImageUrl("0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c"), address: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c", decimals: 18 },
  { label: 'ETH', value: 'ETH', img: getTokenImageUrl("0x2170Ed0880ac9A755fd29B2688956BD959F933F8"), address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8", decimals: 18 },
  // { label: 'MATIC', value: 'MATIC', img: getTokenImageUrl("0xcc42724c6683b7e57334c4e856f4c9965ed682bd"), address: "0xcc42724c6683b7e57334c4e856f4c9965ed682bd", decimals: 18 },
  { label: 'ADA', value: 'ADA', img: getTokenImageUrl("0x3ee2200efb3400fabb9aacf31297cbdd1d435d47"), address: "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47", decimals: 18 },
  { label: 'SOL', value: 'SOL', img: getTokenImageUrl("0x570a5d26f7765ecb712c0924e4de545b89fd43df"), address: "0x570a5d26f7765ecb712c0924e4de545b89fd43df", decimals: 18 },
  { label: 'SHIB', value: 'SHIB', img: getTokenImageUrl("0x2859e4544C4bB03966803b044A93563Bd2D0DD4D"), address: "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D", decimals: 18 },
  { label: 'DOGE', value: 'DOGE', img: getTokenImageUrl("0xba2ae424d960c26247dd6c32edc70b295c744c43"), address: "0xba2ae424d960c26247dd6c32edc70b295c744c43", decimals: 8 },
  { label: 'XRP', value: 'XRP', img: getTokenImageUrl("0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe"), address: "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe", decimals: 18 },
  { label: 'CAKE', value: 'CAKE', img: getTokenImageUrl("0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82"), address: "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82", decimals: 18 },
  { label: 'USDC', value: 'USDC', img: getTokenImageUrl("0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d"), address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d", decimals: 18 },
];


export const Ultra = () => {
  const { library, account, active, } = useWeb3React();
  const isWalletConnected = () => account !== null;
  const contractContext = useContext(ContractContext);
  const contracts = contractContext.contracts;
  const [smartCodeData, setSmartCodeData] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const [ultraTokenContracts, setUltraTokenContracts] = useState({});
  const [data, setData] = useState({});

  const buildUltraTokenContract = useCallback((address) => {
    let web3Instance;
    try {
      web3Instance = new Web3(new HTTPProvider("https://bsc-rpc.publicnode.com"));
    } catch (error) {
      if (library && library.provider) {
        web3Instance = new Web3(library.provider);
      } else {
        console.error("Failed to initialize web3 with both HTTPProvider and library.provider");
        return null;
      }
    }

    if (address.toLowerCase() === "0x27874A586bafaF54d4Cd0aae368ad9569D06d115".toLowerCase())
      return new web3Instance.eth.Contract(ausdAbi, address);
    else
      return new web3Instance.eth.Contract(ultraTokenAbi, address);
  }, [library?.provider]);


  // const buildUltraTokenContract = useCallback((address) => {
  //   if (!library || !library.provider) {
  //     return null;
  //   }
  //   const web3 = new Web3(library.provider);
  //   if (address.toLowerCase() === "0x27874A586bafaF54d4Cd0aae368ad9569D06d115".toLowerCase())
  //     return new web3.eth.Contract(ausdAbi, address);
  //   else
  //     return new web3.eth.Contract(ultraTokenAbi, address);
  // }, [library?.provider]);

  const getTokenPrice = useCallback((tokenAddress) => {
    if (!data || !data.pricingData) return 0; // Default to 0 if pricing data is unavailable
    return data.pricingData?.[tokenAddress.toLowerCase()]?.usd || 0;
}, [data]);


  useEffect(() => {
    if (ultraTokenContracts) {
      //console.log("Ultra Token Contracts:", ultraTokenContracts);
    }
  }, [ultraTokenContracts]);

  useEffect(() => {
    if (smartCodeData) {
      //console.log("Smart Code Data:", smartCodeData);
    }
  }, [smartCodeData]);

  const getSmartCodeDataUser = useCallback(async (user) => {
    const result = await contracts?.smartCodes?.methods.smartCodeData(user).call();
    //console.log("getSmartCodeData:", result);
    return result;
  }, [contracts]);

  const getAllSmartRewardsBnbValues = useCallback(async (contract) => {
    return await contract.methods.getAllSmartRewardsBnbValues().call();
  }, []);

  const getAllSmartRewardsUsdValues = useCallback(async (contract) => {
    return await contract.methods.getAllSmartRewardsUsdValues().call();
  }, []);


  const getPricingData = useCallback(async () => {
    console.log("Fetching pricing data from Liquidity Oracle Paginator...");
    const BATCH_SIZE = 100;
    const pricingData = {};

    const applyPegsAndReplacements = () => {
      // $1 pegs
      pricingData["0x2e3b6906b976ab8da82228e0569b3ef6ea1e8cc6"] = {
        ...(pricingData["0x2e3b6906b976ab8da82228e0569b3ef6ea1e8cc6"] || {}),
        usd: 1.0,
      };
      pricingData["0x27874a586bafaf54d4cd0aae368ad9569d06d115"] = {
        ...(pricingData["0x27874a586bafaf54d4cd0aae368ad9569d06d115"] || {}),
        usd: 1.0,
      };

      // replacements
      const replacements = {
        "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        "0x904B4224acA463666E98f21cC8C54f8D423f6648": "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
        "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA": "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
        "0x3834303483f139c26bc282528aDee6b7Da103D54": "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
        "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8": "0x570a5d26f7765ecb712c0924e4de545b89fd43df",
        "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132": "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D",
        "0x2761c609f3DbA79FFb34d28ab8d9cc2FF381fD3A": "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
        "0xb014728C841D8Ccca6C236fE04B274D206cc60D0": "0xba2ae424d960c26247dd6c32edc70b295c744c43",
        "0x58291c58A2c4AEc7Ad24BaA87988dFc39f3FBC25": "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
      };

      Object.entries(replacements).forEach(([orig, repl]) => {
        const o = orig.toLowerCase();
        const r = repl.toLowerCase();
        if (pricingData[o] && pricingData[r]) {
          pricingData[o] = { ...pricingData[r] };
        }
      });
    };

    const paginator = contracts?.liquidityOraclePaginator;
    if (!paginator?.methods?.getActivePoolTotalCalls) {
      console.error("liquidityOraclePaginator not available in contracts");
      return { pricingData };
    }

    try {
      const totalCallsTuple = await paginator.methods.getActivePoolTotalCalls(BATCH_SIZE).call();
      const totalBatches = Number(totalCallsTuple.totalBatches ?? totalCallsTuple[0] ?? 0);

      for (let page = 0; page < totalBatches; page++) {
        const [bnbTuple, usdTuple] = await Promise.all([
          paginator.methods.getAllSmartRewardsBnbValuesBatch(page, BATCH_SIZE).call(),
          paginator.methods.getAllSmartRewardsUsdValuesBatch(page, BATCH_SIZE).call(),
        ]);

        const bnbTokens = bnbTuple[0] || [];
        const bnbVals   = bnbTuple[1] || [];
        const usdTokens = usdTuple[0] || [];
        const usdVals   = usdTuple[1] || [];

        for (let i = 0; i < bnbTokens.length; i++) {
          const addr = String(bnbTokens[i]).toLowerCase();
          const bnb  = Number(bnbVals[i] || 0) / 1e18;

          // match usd by index if aligned, otherwise by lookup
          let usd = 0;
          if (i < usdTokens.length && String(usdTokens[i]).toLowerCase() === addr) {
            usd = Number(usdVals[i] || 0) / 1e18;
          } else {
            const j = usdTokens.findIndex(t => String(t).toLowerCase() === addr);
            usd = j >= 0 ? Number(usdVals[j] || 0) / 1e18 : 0;
          }

          pricingData[addr] = { bnb, usd };
        }
      }

      applyPegsAndReplacements();
      console.log("Final pricing data:", pricingData);
      return { pricingData };
    } catch (e) {
      console.error("Paginator pricing fetch failed:", e);
      return { pricingData };
    }
  }, [contracts?.liquidityOraclePaginator]);


  const getData = useCallback(async () => {
    if (!isWalletConnected() || !contracts || !contracts.liquidityOracle) {
      //console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }


    try {
      // get pricing data
      const pricingData = await getPricingData();
      const newData = {
        ...pricingData,
      };

      setData(newData); // set the data state only once with the updated data
    } catch (err) {
      console.error("An error occurred while fetching contract data:", err);
    }
  }, [isWalletConnected, contracts, getPricingData]);



  // Ensure we update data whenever there's a change in account, contracts, or other dependencies
  useEffect(() => {
    const initializeDataFetch = async () => {
      if (isWalletConnected() && contracts) {
        await getData();  // Ensure this awaits completion before proceeding
        const userSmartCodeData = await getSmartCodeDataUser(account);
        setSmartCodeData(userSmartCodeData);

        const ultraTokenContracts = ultraSelections.reduce((acc, selection) => {
          const { address } = selection;
          const contract = buildUltraTokenContract(address);
          if (contract) {
            acc[address] = contract;
          }
          return acc;
        }, {});
        setUltraTokenContracts(ultraTokenContracts);
      }
    };

    initializeDataFetch();  // Call the function to initialize data fetch

    const refreshInterval = setInterval(initializeDataFetch, 120000);  // Set periodic data refresh
    return () => clearInterval(refreshInterval);  // Clean up on unmount
  }, [account, contracts, buildUltraTokenContract, ultraSelections]);





  return (

    <div>
      {active
        ?


        <>
          <TabView className="my-tabview" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header="Ultra Dashboard" >

              <Dashboard
                ultraSelections={ultraSelections}
                nativeSelections={nativeSelections}
                selectionPairs={selectionPairs}
                ultraTokenContracts={ultraTokenContracts}
                getTokenPrice={getTokenPrice}
                data={data}
              />

            </TabPanel>
            <TabPanel header="Convert">

              <Convert
                ultraSelections={ultraSelections}
                nativeSelections={nativeSelections}
                selectionPairs={selectionPairs}
                ultraTokenContracts={ultraTokenContracts}
              />

            </TabPanel>


            {/* <TabPanel header="Liquidity Provisioning" disabled>
            </TabPanel> */}
            {/* <TabPanel header="Staking" disabled>
            </TabPanel> */}
          </TabView>
        </>

        :
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', marginTop: '20px', marginLeft: '20px', marginRight: '20px' }}>
          <RenderSplashScreen />
        </div>
      }
    </div>
  );
};

export default React.memo(Ultra);


const RenderSplashScreen = () => {
  const styles = {
    splashContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start', // Changed to flex-start to align items to the top
      alignItems: 'center',
      background: 'none',
      borderRadius: '24px',
      paddingBottom: '20px',
      boxSizing: 'border-box',
      position: 'relative', // Added to position elements absolutely inside
    },
    header: {
      color: 'black',
      fontSize: '1.8em',
      //fontFamily: 'Inter',
      fontWeight: '700',
      textAlign: 'center',
      wordWrap: 'break-word',
      marginBottom: '40px', // Increased margin
      maxWidth: '80%', // Ensure the header text doesn't span the full width
    },
    stepContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start', // Changed to flex-start to align items to the left
      width: '100%',
      gap: '20px', // Increased gap for better spacing
      //marginBottom: '40px', // Increased margin
    },
    stepTitle: {
      color: 'rgba(247, 247, 247, 0.4)',
      fontSize: '2.2em',
      //fontFamily: 'Inter',
      fontWeight: '700',
      alignSelf: 'flex-start', // Align to the start of the flex container
    },
    stepContent: {
      display: 'flex',
      alignItems: 'center', // Adjusted for vertical alignment
      flexDirection: 'row',
      gap: '10px',
    },
    stepIcon: {
      width: '45px',
      height: '45px',
      position: 'absolute',
      top: '0', // Align icons to the top of the overlayIcons div
    },
    stepText: {
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '400',
      textAlign: 'left', // Align text to the left
    },
    overlayIcons: {
      display: 'flex',
      position: 'relative',
      // You might want to adjust the width to prevent the icons from overlapping the text
      width: '120px', // Width should be the total width of the three icons considering their overlap
      height: '45px', // Set the height to that of the icons to prevent overlap with other elements
      justifyContent: 'flex-start', // Aligns the icons to the start
    },
    step1Icon: {
      width: '45px',
      height: '45px',
      position: 'relative', // or 'static' if you don't need any special positioning
      // Other styles specific to step 1 icon
    },
    step2Icon: {
      width: '45px',
      height: '45px',
      position: 'absolute',
      top: '0', // Align icons to the top of the overlayIcons div
    },
    list: {
      listStyle: 'none',
      paddingLeft: '0px', // Set padding to 0 for custom indentation
    },
    listItem: {
      position: 'relative', // Positioned relatively to use absolute for pseudo-elements
      //paddingLeft: '1em', // Space for the bullet
      marginBottom: '0.5em', // Space between list items
      '&::before': {
        content: '"•"', // Unicode character for bullet
        color: '#FBAF00', // Custom color for the bullet, match your design
        position: 'absolute', // Positioned absolutely to place it on the left of the item
        left: '0', // Align to the left
      },
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '400',
    },
    listItemBold: {
      position: 'relative', // Positioned relatively to use absolute for pseudo-elements
      paddingLeft: '1em', // Space for the bullet
      marginBottom: '0.5em', // Space between list items
      '&::before': {
        content: '"•"', // Unicode character for bullet
        color: '#FBAF00', // Custom color for the bullet, match your design
        position: 'absolute', // Positioned absolutely to place it on the left of the item
        left: '0', // Align to the left
      },
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '800',
    },
    dashboardAccess: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start', // This aligns items to the left
      flexWrap: 'nowrap', // Prevents the items from wrapping onto the next line
      gap: '10px', // This adds some space between the icons and the text
    },
    radarIcon: {
      left: '0',
      zIndex: '3',
    },
    refuelIcon: {
      left: '20px',
      zIndex: '2',
    },
    splashIcon: {
      left: '40px',
      zIndex: '1',
    },
  };

  return (
    <div style={styles.splashContainer}>
      <img src={ultraFull} alt="RocketFi" style={{ width: '100%', maxWidth: '500px', position: 'relative' }} />
    </div>
  );
};
